import { render } from "./SectionNavigation.vue?vue&type=template&id=76000a2d&scoped=true"
import script from "./SectionNavigation.vue?vue&type=script&lang=js"
export * from "./SectionNavigation.vue?vue&type=script&lang=js"

import "./SectionNavigation.vue?vue&type=style&index=0&id=76000a2d&scoped=true&lang=scss"

import exportComponent from "/builds/dobro/amway-calculator-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76000a2d"]])

export default __exports__